import { __rest } from "tslib";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import ExpandLeftIcon from "@diligentcorp/atlas-react-icons/lens/ExpandLeft.js";
import ExpandRightIcon from "@diligentcorp/atlas-react-icons/lens/ExpandRight.js";
import { Button } from "@mui/material";
import { applyTokens } from "../../../utilities/applyTokens.js";
const createStates = (state) => {
    const { default: defaultState, hover, focus, disabled } = state;
    return Object.assign(Object.assign({}, applyTokens(defaultState)), { "&:not(.Mui-disabled):hover": Object.assign({}, applyTokens(hover)), "&:not(.Mui-disabled):focus": Object.assign({}, applyTokens(focus)), "&.Mui-disabled": Object.assign({}, applyTokens(disabled)) });
};
export const createAtlasTabScrollButton = ({ LeftIcon, RightIcon }, tokens) => {
    const { semantic: { color }, } = tokens;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const TabScrollButton = (props) => {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const { slots, slotProps, disabled, direction } = props, otherProps = __rest(props, ["slots", "slotProps", "disabled", "direction"]);
        return (_jsxs(Button, Object.assign({ sx: {
                paddingLeft: 0,
                paddingRight: 0,
                // making sure it resizes to different tab heights
                height: "auto",
                flexShrink: 0,
                position: "relative",
                zIndex: 1,
            }, disabled: disabled }, otherProps, { children: [direction === "left" && _jsx(LeftIcon, { color: disabled && color.type.disabled.value }), direction === "right" && _jsx(RightIcon, { color: disabled && color.type.disabled.value })] })));
    };
    return TabScrollButton;
};
const enabledScrollButton = ".MuiTabs-scrollButtons:not([disabled])";
const tabs = (tokens) => {
    const { core: { spacing }, component: { tabs }, } = tokens;
    const { active, inactive, icon, badge } = tabs;
    const scrollFadeWidth = spacing["3"].value;
    return {
        MuiTabs: {
            defaultProps: {
                ScrollButtonComponent: createAtlasTabScrollButton({
                    LeftIcon: ExpandLeftIcon,
                    RightIcon: ExpandRightIcon,
                }, tokens),
            },
            styleOverrides: {
                root: {
                    minHeight: tabs.sizes.medium.button.height.value,
                    overflow: "visible",
                    borderBottom: "none",
                    alignItems: "center",
                    "&.atlas-size-large": {
                        height: tabs.sizes.large.button.height.value,
                        "& .MuiTab-root": Object.assign(Object.assign({}, applyTokens(tabs.sizes.large.button)), { paddingTop: 0, paddingBottom: 0 }),
                        "& .MuiTabs-scrollButtons": {
                            width: `${tabs.sizes.large.button.height.value} !important`,
                            height: tabs.sizes.large.button.height.value,
                        },
                        "& .MuiTabs-flexContainer": {
                            gap: tabs.sizes.large.container.gap.value,
                        },
                    },
                    ".MuiTabs-flexContainer": Object.assign(Object.assign({}, applyTokens(tabs)), { gap: tabs.sizes.medium.container.gap.value }),
                    "& .MuiTabs-scrollButtons": {
                        width: `${tabs.sizes.medium.button.height.value} !important`,
                        height: tabs.sizes.medium.button.height.value,
                    },
                    [`&:has(${enabledScrollButton} ~ .MuiTabs-scroller)`]: {
                        ".MuiTabs-scroller": {
                            maskImage: `linear-gradient(to right, transparent, black ${scrollFadeWidth})`,
                        },
                    },
                    [`&:has(.MuiTabs-scroller ~ ${enabledScrollButton})`]: {
                        ".MuiTabs-scroller": {
                            maskImage: `linear-gradient(to left, transparent, black ${scrollFadeWidth})`,
                        },
                    },
                    [`&:has(${enabledScrollButton} ~ .MuiTabs-scroller ~ ${enabledScrollButton})`]: {
                        ".MuiTabs-scroller": {
                            maskImage: `linear-gradient(to right, transparent 0, black ${scrollFadeWidth}, black calc(100% - ${scrollFadeWidth}), transparent 100%)`,
                        },
                    },
                },
                indicator: {
                    display: "none",
                },
                fixed: {
                    "&.MuiTabs-scroller": {
                        "&&&": {
                            // MUI sets overflow:hidden inline :(
                            // https://github.com/mui/material-ui/blob/32c33b5dfa835cc0b29a219e6d915b178ab15b8d/packages/mui-material/src/Tabs/Tabs.js#L305
                            overflow: "visible !important",
                        },
                    },
                },
            },
        },
        MuiTab: {
            styleOverrides: {
                root: Object.assign(Object.assign(Object.assign(Object.assign({}, applyTokens(tabs.sizes.medium.button)), { minHeight: tabs.sizes.medium.button.height.value, minWidth: "auto", flexDirection: "row" }), createStates({
                    default: inactive.default,
                    hover: inactive.hover,
                    focus: inactive.focus,
                    disabled: inactive.disabled,
                })), { "&.Mui-selected:not(.Mui-disabled)": Object.assign(Object.assign({}, createStates({
                        default: active.default,
                        hover: active.hover,
                        focus: active.focus,
                        disabled: active.disabled,
                    })), { ".MuiBadge-badge": Object.assign({}, applyTokens(badge.active)) }), "& > .MuiTab-iconWrapper": {
                        marginRight: 0,
                        marginBottom: 0,
                    }, "& > svg ": Object.assign({}, applyTokens(icon)), ".MuiBadge-root": {
                        ".MuiBadge-badge": Object.assign(Object.assign(Object.assign({}, applyTokens(badge)), applyTokens(badge.inactive)), { position: "relative", transform: "none", top: "0", right: "0" }),
                    } }),
            },
        },
    };
};
export default tabs;
//# sourceMappingURL=tabs.js.map